import type { B24Frame } from '@bitrix24/b24jssdk';

let framePromise: Promise<B24Frame> | null = null;

export function isInFrame(): boolean {
  try { return window.self !== window.top; } catch { return true; }
}

export function getFrame(timeoutMs = 10_000): Promise<B24Frame> {
  if (!framePromise) {
    framePromise = Promise.race([
      import('@bitrix24/b24jssdk').then((m) => m.initializeB24Frame()),
      new Promise<never>((_, rej) => setTimeout(() => rej(new Error('frame-timeout')), timeoutMs)),
    ]).catch((e) => { framePromise = null; throw e; });
  }
  return framePromise;
}

export async function readPlacement(): Promise<{ placement: string; options: Record<string, unknown> }> {
  const f = await getFrame();
  return { placement: f.placement.placement, options: (f.placement.options ?? {}) as Record<string, unknown> };
}

/** Вкладка карточки CRM: высота фрейма под содержимое. */
export async function fitFrame(minHeight = 400): Promise<void> {
  const f = await getFrame();
  await f.parent.resizeWindowAuto(document.body, minHeight);
}

export async function openAppSlider(params: Record<string, unknown>): Promise<void> {
  await (await getFrame()).slider.openSliderAppPage(params);
}

export async function openPortalPath(path: string, width?: number): Promise<void> {
  const f = await getFrame();
  await f.slider.openPath(f.slider.getUrl(path), width);
}
